import { createActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import paymentsApi from '../../api/paymentsApi';
import startupConfig from '../../lib/startupConfig';
import { Dispatch } from 'react';

export const { getStartupConfigFulfilled, getStartupConfigPending, getStartupConfigRejected } = createActions(
  actionTypes.GET_STARTUP_CONFIG_FULFILLED,
  actionTypes.GET_STARTUP_CONFIG_PENDING,
  actionTypes.GET_STARTUP_CONFIG_REJECTED,
  getActionOptions(ACTION_PREFIX)
);

const getLocalConfig = () =>
  Promise.resolve({
    data: {
      ...startupConfig.get(),
      identityServerApiUrl: process.env.REACT_APP_IDENTITY_SERVER_URL,
      paymentsUiUrl: process.env.REACT_APP_PAYMENTS_UI_URL,
      instrumentationKey: process.env.REACT_APP_AI_INSTRUMENTATION_KEY,
      mfKey: process.env.REACT_APP_MOUSEFLOW_KEY,
    },
  });

const getStartupConfig =
  () =>
  (dispatch: Dispatch<any>): Promise<any> => {
    dispatch(getStartupConfigPending());

    const getConfig = process.env.REACT_APP_STAND_ALONE ? getLocalConfig : paymentsApi.getStartupConfig;

    return getConfig()
      .then((response) => dispatch(getStartupConfigFulfilled(response.data)))
      .catch((error) => dispatch(getStartupConfigRejected(error)));
  };

export default {
  getStartupConfig,
};
